import { createStaticApp } from '@ori-appshell/rendering';
import { APP_NAME } from '~/constants-generated';
import { EMOTION_CACHE_KEY } from '../constants';
export default createStaticApp({
    emotionCacheKey: EMOTION_CACHE_KEY,
    appName: APP_NAME
});
